// extracted by mini-css-extract-plugin
export var active = "_ep-2";
export var recordingDot = "_ep-1";
export var recordingIndicator = "_ep-0";